import { FC } from 'react';
import { ArrowLeft } from 'react-feather';
import styled from 'styled-components';
import { Flex } from '.';
import { useRouter } from '../../hooks';
import { P, Span } from '../../typography';

const styleProgressWrapper = {
  backgroundColor: '#fff',
};

const GoBackText = styled(P as any)`
  padding-bottom: 10px;
  width: 75%;
`;

const BackArrow = styled(Span as any)`
  padding-top: 10px;
  width: 10%;
`;

const GoBack: FC<{}> = () => {
  const { history } = useRouter();
  return (
    <Flex direction="row" size="1" style={styleProgressWrapper} onClick={() => history.goBack()}>
      <BackArrow>
        <ArrowLeft />
      </BackArrow>
      <GoBackText>Go Back</GoBackText>
    </Flex>
  );
};

export default GoBack;
